const language_en = {

}

export default language_en;
